<!-- 基础配置主页面 -->
<template>
    <div class="full-height">
        <Panel v-loading="loading" title="配置管理" class="margin-3 padding-1">
            <template slot="buttons">
              <el-button class="blue" @click="handleEasyConfigEditor()" icon="el-icon-fa-pencil-square-o">配置编辑</el-button>
              <!--                <el-button type="primary" @click="startAllTL()" icon="el-icon-fa-play">全部开始</el-button>-->
              <!--                <el-button type="primary" @click="stopAllTL()" icon="el-icon-fa-stop">全部停止</el-button>-->
<!--              <el-button class="green" @click="filePersistent()" icon="el-icon-fa-search">数据查询</el-button>-->
              <el-button class="green" @click="paramgr()" icon="el-icon-s-tools">参数设置</el-button>
              <el-button class="green" @click="bizmgr()" icon="el-icon-fa-exchange ">业务查询</el-button>
              <el-button class="yellow" @click="environmentalTesting()" icon="el-icon-fa-check-circle">环境检测</el-button>
              <el-button class="red" @click="refresh()" icon="el-icon-fa-refresh">刷新列表</el-button>
            </template>
            <div style="height: calc(100vh - 550px)">
                <TransChartShow style="height: 100%;width: 100%" ref="transChart"></TransChartShow>
            </div>

            <fieldset class="margin-top-2 padding-1">
                <legend>终端业务运行列表</legend>
                <PageTable hideTitle hideExport ref="dataTable" :data="dataTable" @load-data="dataTableLoad" highlight-current-row stripe border height=330 >
                    <el-table-column prop="bizname" label="业务名称" show-tooltip-when-overflow align="center"/>
                    <el-table-column prop="bizdxpid" label="业务系统DXPID" show-tooltip-when-overflow align="center"/>
                    <el-table-column prop="biztype" label="传输业务类型" show-tooltip-when-overflow align="center" width="180"/>
                    <el-table-column prop="clioutdir" label="数据申报路径" show-tooltip-when-overflow align="center"/>
                    <el-table-column prop="cliindir" label="回执接收路径" show-tooltip-when-overflow align="center"/>
                    <el-table-column prop="csstatus" label="运行状态" show-tooltip-when-overflow align="center" width="200">
                        <template slot-scope="{ row }">
                            <el-tag v-if="row.csstatus === '-1'" type="warning">初始化失败</el-tag>
                            <el-tag v-else-if="row.csstatus === '0'" type="info">未初始化</el-tag>
                            <el-tag v-else-if="row.csstatus === '1'" type="info">初始化成功</el-tag>
                            <el-tag v-else-if="row.csstatus === '2'" type="success">已启动</el-tag>
                            <el-tag v-else-if="row.csstatus === '-2'" type="warning">已停用</el-tag>
                            <el-tag v-else-if="row.csstatus === '-3'" type="danger">已停止</el-tag>
                            <el-tag v-else>初始化</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center">
                        <template slot-scope="{ row }">
                            <el-button class="green" @click="startTL(row)" icon="el-icon-fa-play" v-if="row.csstatus">启动</el-button>
                            <el-button class="red" @click="stopTL(row)" icon="el-icon-fa-stop" v-if="row.csstatus">停止</el-button>
                        </template>
                    </el-table-column>
                </PageTable>
            </fieldset>
        </Panel>
        <div class="basebottom">
            <el-link type="primary" href=" http://osp.cnetong.com" target="_blank" icon="el-icon-fa-internet-explorer" class="basebottomfont"><span>安易通数据交换企业服务平台</span>
            </el-link>
            <el-link type="primary" @click="showVersionInfo()" icon="el-icon-fa-vimeo" class="basebottomfont"><span>当前版本 {{this.version}}</span></el-link>
            <el-link type="primary" :underline="false" icon="el-icon-date" class="basebottomfont_"><span>{{ dateTime }}</span></el-link>
        </div>
        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="easyConfigEditor.show" title="配置信息编辑" width="1080px">
            <div class="dialog-button">
              <el-button-group>
                <el-button class="blue" icon="el-icon-fa-save" @click="doSubmit()">保存</el-button>
              </el-button-group>
              <div style="display: inline-block;">
                <el-button-group>
                  <el-upload action="/" :on-change="importConfig" :show-file-list="false" :multiple="false" :auto-upload="false">
                    <el-button class="blue" slot="trigger" icon="el-icon-fa-plug">本地导入</el-button>
                  </el-upload>
                </el-button-group>
              </div>

            </div>
            <EasyConfig style="min-height: 250px;" v-if="easyConfigEditor.show" ref="easyConfigEditor" :data="easyConfigEditor.data"
                        @refresh="refresh"/>
        </el-dialog>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="persistentFile.show" title="文件持久化查询" width="1080px">
            <PersistentFile style="min-height: 200px;" v-if="persistentFile.show" ref="persistentFile"></PersistentFile>
        </el-dialog>
      <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="biz.show" title="业务链查询" width="1080px">
        <BizChain style="min-height: 200px;" v-if="biz.show" ref="bizmgr"></BizChain>
      </el-dialog>
        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="para.show" title="参数设置" width="500px">
            <div class="dialog-button">
                <el-button type="success" icon="el-icon-fa-save" @click="doSubmitPara()">保存</el-button>
            </div>
            <ParaConfig v-if="para.show" ref="paraconfig"></ParaConfig>
        </el-dialog>
      <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="versionshow.show" title="版本信息" width="500px">
        <VersionShow  v-if="versionshow.show" ref="VersionShow"></VersionShow>
      </el-dialog>
    </div>
</template>

<script>
import EasyConfigApi from "@/api/basics/EasyConfigApi";
import TransChartShow from "./TransChartShow.vue"; // 传输流程展示图形
import EasyConfig from "./EasyConfig.vue"; // 配置页面
import PersistentFile from "../filepersistent/FilePersistent.vue"; // 配置页面
import ParaConfig from "./ParaConfig"
import BizChain from "../rsrcmgr/bizchain/BizChain.vue"
import VersionShow from "./Version";
import HeaderApi from "@/module/layout/header/Header";

var week = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
];
export default {
    name: "BasicsConfigMain",
    components: {TransChartShow, EasyConfig, PersistentFile, ParaConfig,BizChain,VersionShow},
    data() {
        return {
            isOnlineSupport:true,
            version: "V1.0.0",
            charts: "",
            dataTable: [],
            loading: false,
            easyConfigEditor: {
                show: false,
                data: {}
            },
            persistentFile: {
                show: false,
            },
            para: {
                show: false,
            },
            biz: {
              show:false
            },
            versionshow:{
              show: false,
            },
            dateTime: "2020-01-01 00:00:00",
        };
    },
    computed: {
        queryTrigger() {
            return this.$store.state.client.monitorRefreshTrigger;
        },
    },
    watch: {
        queryTrigger: "query"
    },
    async mounted() {
      this.query();
      this.updateTime();
    },
    created: function () {
      EasyConfigApi.doGetVersion().then(resp=>{
        this.version = resp.versionNo;
      });
      EasyConfigApi.isOnlineSupport().then(resp=>{
        this.isOnlineSupport = resp.isOnlineSupport;
      })

    },
    methods: {
        query() {
            this.$refs.dataTable.load();
        },
        handleEasyConfigEditor() {
            this.easyConfigEditor.show = true;
        },
        // 配置导入
        async importConfig(file, fileList) {
            if (!file.name.endsWith('.json')) {
                this.$message.error('请上传正确的JSON文件!');
                return;
            }
            try {
                this.loading = true;
                let fd = new FormData();
                fd.append("file", file.raw, file.name);
                await EasyConfigApi.importConfig(fd);
                await this.easyConfigRefush();
                this.loading = false;
            } catch (e) {
              this.loading = false;
            }
        },
        async easyConfigRefush() {
          this.$refs.easyConfigEditor.refush();
        },
        // 配置导出
        async exportConfig() {
            this.$refs.easyConfigEditor.exportConfig();
        },
        // 保存参数设置
        doSubmitPara() {
            this.$refs.paraconfig.save();
        },
        // 保存基础信息
        doSubmit() {
            this.$refs.easyConfigEditor.saveBasics();
        },
        refresh() {
          this.loading = true;
          this.$refs.dataTable.load();
          this.loading = false;
        },
        dataTableLoad(params, resolve) {
            EasyConfigApi.doQueryLocalBiz(params)
                .then(resolve) // 让表格解析你提供的数据 (主要解析页码等)
                .then(respData => {
                    this.dataTable = respData.datarows;
                });
        },
        // 启动终端
        startTL(row) {
            EasyConfigApi.startBizRes(row.uuid).then(() => this.refresh());

        },
        // 停止终端
        stopTL(row) {
            EasyConfigApi.stopBizRes(row.uuid).then(() => this.refresh());
        },
        // 启动全部终端
        startAllTL() {
            EasyConfigApi.startAllRes().then(() => this.refresh());
        },
        // 停止全部终端
        stopAllTL() {
            EasyConfigApi.stopAllRes().then(() => this.refresh());
        },
        // 环境监测
        environmentalTesting() {
            this.$refs.transChart.environmentalTesting();
            this.$refs.transChart.basicsEnvironmentalTesting();
        },
        // 参数设置
        paramgr() {
            this.para.show = true;
        },
        // 业务链管理
        bizmgr() {
          this.biz.show = true;
        },
        filePersistent() {
            this.persistentFile.show = true;
            // this.addView("文件持久化查询", "/monitormgr/PersistentFile");
        },
        addView(name, path, propsData) {
            let idx = this.$tabView.viewList.findIndex((item) => item.name === name);
            if (idx === -1) this.$tabView.viewList.push({name, path, propsData});
            this.$tabView.active = name;
        },
        //展示版本信息
        showVersionInfo(){
          this.versionshow.show = true;
        },
        // 在綫配置拉取
        onlinePull(){
          this.$refs.easyConfigEditor.onlinePull();
        },
        updateTime() {
            setInterval(() => {
                var cd = new Date();
                this.dateTime =
                    "  " +
                    this.zeroPadding(cd.getFullYear(), 4) +
                    "-" +
                    this.zeroPadding(cd.getMonth() + 1, 2) +
                    "-" +
                    this.zeroPadding(cd.getDate(), 2) +
                    " " +
                    this.zeroPadding(cd.getHours(), 2) +
                    ":" +
                    this.zeroPadding(cd.getMinutes(), 2) +
                    ":" +
                    this.zeroPadding(cd.getSeconds(), 2) +
                    " " +
                    week[cd.getDay()];
            }, 1000);
        },
        zeroPadding(num, digit) {
            var zero = "";
            for (var i = 0; i < digit; i++) {
                zero += "0";
            }
            return (zero + num).slice(-digit);
        },
    },
};
</script>
<style lang="scss">
.very-simple-mode {
    .el-tabs__header, .app-container__viewsCtrl, .el-scrollbar, .version_btn {
        display: none;
    }

    .el-tabs__content {
        padding-top: 0 !important;
    }
}

.basebottom {
    margin-right: 5px;
    margin-left: 5px;
    height: 25px;
    background-color: #ecf0f4;
    border: 0.5px solid #bfcbd9;
    border-radius: 5px
}

.basebottomfont {
    float: right;
    margin-right: 20px;
    font-size: 15px;
}

.basebottomfont_ {
    float: left;
    margin-left: 20px;
    font-size: 15px;
}
</style>